/*
 * For any production configuration environment variables or constants we wanna use...
 */
const CONFIG = {
    ENVIRONMENT: false,
}

export default CONFIG;
